<template lang="html">
  <div style="position:relative;">
    <ComHeader type="4" :title="'详情页'" />
    <Header :plateBasicInfo="plateBasicInfo" :plateStatus="plateStatus" :plateDyna="plateDyna"
      :plateStatistics="plateStatistics" :showSearchIcon="false" />
    <DataPanel :plateBasicInfo="plateBasicInfo" :plateStatus="plateStatus" :plateDyna="plateDyna"
      :plateStatistics="plateStatistics" />
    <PlateMainChart v-if="plateBasicInfo.hqTypeCode && plateStatistics.PreClosePrice" :plateBasicInfo="plateBasicInfo"
      :statistic="plateStatistics" :typeCode="typeCode" :prodCode="prodCode" />
    <Tabs :totalCount="(panelData && panelData.memberCount) || 0" />
    <div class="app-link" @click="openAppStore">
      <div style="display: flex;align-items: center;justify-content: space-between;height:100%;">
        <img :src="logoUrl" class="logo" />
        <div class="download-btn">
          立即下载
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/request";
import PlateMainChart from "../home/MainChart/PlateMainChart.vue";
import Header from "./Header/index.vue";
import DataPanel from "./DataPanel/index.vue";
import Tabs from "./Tabs/index.vue";
import { ws } from "@/websocket";

import ComHeader from "@/components/common/comHeader.vue";

export default {
  components: {
    ComHeader,
    Header,
    DataPanel,
    Tabs,
    PlateMainChart,
  },
  data() {
    return {
      logoUrl: 'https://uploads.9fzt.com/production/jfztgwwap/assets/img/logo-jfzt.png',
      prodCode: "",
      typeCode: "",
      panelData: {},
      title: "",
      // new
      plateBasicInfo: {},
      plateDyna: {},
      plateStatus: {},
      plateStatistics: {},
    };
  },
  computed: {},
  async created() {
    window.scrollTo(0, 0);
    this.prodCode = this.$route.params.prodCode;
    this.typeCode = this.$route.params.typeCode;
    this.getPlateBasicInfo();
  },
  mounted() { },
  beforeDestroy() {
    document.removeEventListener("scroll", this.hanldeAppLink);
  },
  methods: {
    async getPlateBasicInfo() {
      const result = await request._get(
        request.apis.plateChart.plateBasicInfo,
        {
          market: this.typeCode,
          symbol: this.prodCode,
        },
        true,
        true,
        '9fztgw',
        true
      );
      this.plateBasicInfo = result;
      this.handleWebsocket();
    },
    handleWebsocket() {
      const {
        hqTypeCode: market,
        instrumentID: symbol,
        exchangeID,
      } = this.plateBasicInfo;

      ws.init();
      // 订阅和接收行情数据,订阅之前先安全取消
      ws.websocket.safeUnsubscribeDYNA(symbol, exchangeID, 203);
      ws.websocket.safeSubscribeDYNA(symbol, exchangeID, 203);
      ws.websocket.on("onDYNA", (msg) => {
        if (msg.Inst === symbol) {
          this.plateDyna = msg.QuoteData.DynaData[0];
        }
      });

      // 订阅开盘状态
      ws.websocket.safeSubscribeSTATUS(symbol, exchangeID);
      ws.websocket.on("onSTATUS", (msg) => {
        if (msg.Inst === symbol) {
          this.plateStatus = msg.QuoteData.InstStatusData[0];
        }
      });

      // 昨收、开盘价格等
      ws.websocket.safeUnsubscribeSTATISTICS(symbol, exchangeID, 203);
      ws.websocket.safeSubscribeSTATISTICS(symbol, exchangeID, 203);
      ws.websocket.on("onSTATISTICS", (msg) => {
        if (msg.Inst === symbol) {
          this.plateStatistics = msg.QuoteData.StatisticsData[0];
        }
      });
    },
    openAppStore() {
      window.open(`https://h5.chongnengjihua.com/rjhy/activity-h5/x-jfql-weichat.html?t=operation&c=o_d_o_ydgw1208`);
    },
  },
};
</script>
<style lang="stylus" scoped>
.app-link
    position fixed
    bottom 0
    padding 0 16px
    width 100%
    height 64px
    z-index 99
    background #ffffff
    box-sizing border-box
    box-shadow 0 0 4px 0 rgba(0, 0, 0, 0.25)

.download-btn {
    width: 1rem;
    height: 0.34rem;
    display: block;

    line-height: 0.34rem;
    background: #E94041;
    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
}

.logo {
  width: 1.66rem;
  height: 0.4rem;
}
</style>
